module.exports = __webpack_public_path__ + "static/img/certificate.dc0aef8b.png";